export default {
  path: '/sales-analytics',
  name: 'sales-analytics',
  component: () => import('@/modules/sales-analytics/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: "Track your Etsy shop's sales and revenue in one place. Discover how your revenue trends over the year and what country your buyers live in.",
      },
      {
        property: 'og:title',
        content: 'eRank — Sales Analytics',
      },
      {
        property: 'og:description',
        content: "Track your Etsy shop's sales and revenue in one place. Discover how your revenue trends over the year and what country your buyers live in.",
      },
      { page_slug: 'sales-analytics' },
    ],
    requiresAuth: true,
    title: 'eRank — Sales Analytics',
  },
};
